import * as React from 'react';
import cx from 'classnames';
import { CnPopover } from '@/components/cn-popover';
import { CnIcon } from '@/components/cn-icon';
import './index.scss';
import classNames from 'classnames';
/**
 * @category 组件
 * @description 表单字段容器
 */
export class CnFormItem extends React.Component {
    static displayName = 'CnFormItem';
    renderLabel() {
        const { required, asterisk, title, tip, extra, readOnly, labelWidth, labelAlign, labelTextAlign, } = this.props;
        let requiredStatus = false;
        if (required || asterisk) {
            requiredStatus = true;
        }
        if (readOnly) {
            requiredStatus = false;
        }
        return (React.createElement("div", { className: classNames('cn-ui-m-form-item-label', {
                ['cn-ui-m-form-item-label--left']: labelAlign === 'left',
                [`cn-ui-m-form-item-label--text-${labelTextAlign}`]: !!labelTextAlign,
            }), style: labelAlign === 'left'
                ? {
                    width: labelWidth,
                    flexShrink: 0,
                }
                : {} },
            React.createElement("div", { className: "cn-ui-m-form-item-label-content" },
                React.createElement("div", { className: "cn-ui-m-form-item-label-title" }, title),
                tip ? (React.createElement(CnPopover, { content: tip, trigger: "click", placement: "top" },
                    React.createElement(CnIcon, { className: "cn-ui-m-form-item-label-tip", type: "help", size: "xs" }))) : null,
                requiredStatus && (React.createElement("div", { className: "cn-ui-m-form-item-required" }, '*'))),
            extra ? (React.createElement("div", { className: "cn-ui-m-form-item-label-extra" }, extra)) : null));
    }
    renderWrapper() {
        const { children, wrapperAlign } = this.props;
        return (React.createElement("div", { key: "control", className: classNames('cn-ui-m-form-item-control', {
                [`cn-ui-m-form-item-control--${wrapperAlign}`]: !!wrapperAlign,
            }) }, React.isValidElement(children)
            ? React.cloneElement(children, {
                insideForm: true,
            })
            : children));
    }
    renderIcon() {
        const { hasArrow, errors, triggerName } = this.props;
        const classes = cx('cn-ui-m-form-item-icon', {
            'cn-ui-m-form-item-icon--error': Array.isArray(errors) && errors.length > 0,
        });
        // 如放置组件为 CnSelect 等需要显示 arrow
        if (hasArrow && triggerName && ['CnSelect'].indexOf(triggerName) > 0) {
            return (React.createElement("div", { className: "cn-ui-m-form-item-header--ft" },
                React.createElement("div", { className: classes },
                    React.createElement(CnIcon, { type: "icon-arrow-right", size: "large" }))));
        }
        return null;
    }
    renderErrors() {
        const { errors } = this.props;
        const componentArray = [];
        if (Array.isArray(errors) && errors.length > 0) {
            componentArray.push(React.createElement("div", { key: "error", className: "cn-ui-m-form-item-error" }, errors.map((errorItem) => `${errorItem}${errors.length > 1 ? ';' : ''}`)));
        }
        return React.createElement("div", { className: "cn-ui-m-form-item-footer" }, componentArray);
    }
    onItemClick = () => {
        const { triggerName, triggerRef } = this.props;
        if (triggerName && triggerRef) {
            if (triggerName === 'CnInput') {
                triggerRef.current?.focus();
            }
            if (triggerName === 'CnSelect') {
                triggerRef.current?.show();
            }
        }
    };
    render() {
        const { className, errors, style, id, disabled, labelAlign } = this.props;
        const hasError = Array.isArray(errors) && errors.length > 0;
        const classes = cx(className, {
            'cn-ui-m-form-item': true,
            [`cn-ui-m-form-item--left`]: labelAlign === 'left',
            'cn-ui-m-form-item-disabled': disabled,
        });
        const headerClasses = cx('cn-ui-m-form-item-header', {
            'has-error': hasError,
        });
        return (React.createElement("div", { style: style, className: classes, id: id, role: "cn-form-item-m", onClick: this.onItemClick },
            React.createElement("div", { className: headerClasses },
                React.createElement("div", { className: "cn-ui-m-form-item-header--hd" },
                    this.renderLabel(),
                    this.renderWrapper()),
                this.renderIcon()),
            this.renderErrors()));
    }
}
